export const TRANSLATIONS_ES_PLANS_AND_ADMIN = {
  "usage.title": "Mi plan y uso",
  "usage.subtitle": "Revisa tu plan actual, límites y actividad reciente.",
  "usage.plan": "Plan",
  "usage.plan_unknown": "Plan no disponible",
  "usage.unlimited": "Ilimitado",
  "usage.over_limit_blocking": "Límite alcanzado",
  "usage.over_limit_allowed": "Sobre el límite permitido",
  "usage.error.forbidden": "No tienes permiso para ver el uso de esta cuenta.",
  "usage.error.generic": "No pudimos cargar el uso de tu plan.",
  "usage.error.retry": "Reintentar",
  "usage.status.active": "Activo",
  "usage.status.trialing": "En periodo de prueba",
  "usage.status.cancelled": "Cancelado",
  "usage.status.expired": "Expirado",
  "usage.status.suspended": "Suspendido",
  "usage.enforcement.hard": "Bloqueo estricto",
  "usage.enforcement.soft": "Flexible",
  "usage.enforcement.dry_run": "Solo monitoreo",
  "usage.unit.count": "consultas",
  "usage.unit.tokens": "tokens",
  "usage.unit.pages": "páginas",
  "usage.unit.bytes": "bytes",
  "usage.unit.monthly_chat_queries": "consultas",
  "usage.unit.monthly_csv_queries": "consultas",
  "usage.unit.monthly_documents_uploaded": "documentos",
  "usage.unit.users_per_account": "usuarios",
  "usage.unit.monthly_ocr_pages": "páginas",
  "usage.freshness.no_snapshot": "Sin datos disponibles",
  "usage.freshness.stale": "Datos desactualizados",
  "usage.freshness.updating": "Actualizando datos",
  "usage.freshness.fresh": "Datos al día",
  "usage.flag.missing_subscription": "Sin suscripción",
  "usage.flag.usage_not_evaluated": "Sin evaluar",
  "usage.flag.missing_model_policy": "Falta política de modelo",
  "usage.flag.source_unavailable": "Fuente no disponible",
  "usage.flag.source_error": "Error temporal",
  "usage.flag.snapshot_stale": "Datos desactualizados",
  "usage.flag.legacy": "Datos heredados",
  "usage.limit.monthly_chat_queries": "Preguntas de chat mensuales",
  "usage.limit.monthly_llm_tokens": "Tokens LLM mensuales",
  "usage.limit.monthly_documents_uploaded": "Documentos subidos mensuales",
  "usage.limit.monthly_csv_queries": "Consultas CSV mensuales",
  "usage.limit.monthly_ocr_pages": "Páginas OCR mensuales",
  "usage.limit.users_per_account": "Usuarios activos por cuenta",
  "usage.limit.storage_bytes": "Almacenamiento",
  "usage.decisions.title": "Decisiones recientes",
  "usage.decisions.empty": "No hay decisiones registradas aún.",
  "usage.decisions.allowed": "Permitido",
  "usage.decisions.blocked": "Bloqueado",
  "usage.decisions.pager": "Paginación de decisiones",
  "usage.decisions.col.timestamp": "Fecha",
  "usage.decisions.col.module": "Módulo",
  "usage.decisions.col.operation": "Operación",
  "usage.decisions.col.limit": "Límite",
  "usage.decisions.col.decision": "Decisión",
  "usage.trial.banner": "Tu periodo de prueba termina en {{days}} días. Cambia a un plan para no perder acceso.",
  "usage.trial.banner_one": "Tu periodo de prueba termina en {{days}} día. Cambia a un plan para no perder acceso.",
  "usage.trial.cta": "Ver planes",
  "usage.consumed": "Consumido",
  "usage.limit_value": "Límite",
  "usage.period.month": "este mes",
  "usage.hero.title": "Consumo clave del periodo",
  "usage.hero.used": "usado",
  "usage.hero.no_data": "Sin datos aún",
  "enforcement.banner.title": "Límite del plan alcanzado",
  "enforcement.banner.body": "Has alcanzado el límite configurado de tu plan.",
  "enforcement.banner.cta": "Ver mi plan",
  "payments.upgrade.title": "Cambia tu plan",
  "payments.upgrade.subtitle": "Selecciona un plan disponible y paga con Wompi Sandbox. Confirmaremos el cambio contra backend.",
  "payments.upgrade.select_plan": "Plan destino",
  "payments.upgrade.no_options": "No hay planes disponibles para cambiar desde esta cuenta.",
  "payments.change_plan": "Cambiar plan",
  "payments.contact_sales": "Contactar ventas",
  "payments.confirm.title": "Confirmar pago",
  "payments.confirm.body": "Vas a crear una orden para",
  "payments.confirm.pay": "Crear orden y pagar",
  "payments.creating_order": "Creando orden...",
  "payments.status.idle": "Sin pago activo",
  "payments.status.checking_pending": "Consultando orden pendiente",
  "payments.status.creating_order": "Creando orden",
  "payments.status.widget_open": "Formulario de pago abierto",
  "payments.status.pending_confirmation": "Estamos confirmando tu pago.",
  "payments.status.approved": "Pago aprobado. Tu plan fue actualizado.",
  "payments.status.declined": "Pago rechazado",
  "payments.status.voided": "La transaccion fue anulada.",
  "payments.status.expired": "Orden expirada",
  "payments.status.error": "No pudimos validar el pago",
  "payments.error.invalid_request": "No pudimos crear la orden. Verifica el plan y el precio.",
  "payments.error.session": "Tu sesion expiro. Inicia sesion nuevamente.",
  "payments.error.forbidden": "No tienes permisos para cambiar el plan de esta cuenta.",
  "payments.error.unconfigured": "Wompi no esta configurado en backend.",
  "payments.error.generic": "No pudimos iniciar el pago.",
  "payments.reference": "Referencia",
  "payments.result.title": "Resultado del pago",
  "payments.result.subtitle": "El redirect no aprueba el pago. Validamos el estado contra backend.",
  "payments.result.back_to_usage": "Volver a Mi plan",
  "payments.eligible": "Elegible",
  "payments.ineligible.no_price": "Sin precio",
  "payments.ineligible.inactive": "Precio inactivo",
  "payments.ineligible.custom": "Precio custom",
  "payments.ineligible.currency": "Solo COP",
  "payments.ineligible.amount": "Monto no valido",
  "plans.admin.title": "Planes",
  "plans.admin.subtitle": "Catalogo y componentes de planes.",
  "plans.admin.include_inactive": "Incluir inactivos",
  "plans.admin.back": "Volver a planes",
  "plans.admin.tab.plans": "Planes",
  "plans.admin.tab.over_limit": "Sobre límite",
  "plans.admin.tab.llm_usage": "Uso LLM",
  "plans.code": "Codigo",
  "plans.name": "Nombre",
  "plans.description": "Descripcion",
  "plans.active": "Activo",
  "plans.inactive": "Inactivo",
  "plans.enabled": "Habilitado",
  "plans.saved": "Cambios guardados.",
  "plans.sort_order": "Orden",
  "plans.tab.general": "General",
  "plans.tab.features": "Features",
  "plans.tab.limits": "Limits",
  "plans.tab.prices": "Prices",
  "plans.tab.models": "Model policies",
  "plans.unlimited": "Ilimitado",
  "plans.currency": "Moneda",
  "plans.amount": "Monto",
  "plans.period": "Periodo",
  "plans.sandbox_account_id": "AccountId sandbox",
  "plans.sandbox_payment": "Probar sandbox",
  "plans.sandbox_missing_account": "Ingresa un accountId sandbox valido.",
  "plans.sandbox_started": "Flujo sandbox iniciado.",
  "plans.sandbox_error": "No pudimos iniciar el flujo sandbox.",
  "plans.default_model": "Modelo default",
  "plans.account": "Cuenta",
  "plans.change_plan": "Cambiar plan",
  "plans.subscriptions.title": "Suscripciones",
  "plans.subscriptions.subtitle": "Soporte manual de plan y estado. No sustituye el flujo comercial Wompi.",
  "plans.subscriptions.active": "Suscripcion activa",
  "plans.subscriptions.create": "Crear suscripcion",
  "plans.subscriptions.saved": "Suscripcion actualizada.",
  "plans.subscriptions.open": "Abrir suscripciones",
  "plans.over_limit.title": "Cuentas sobre limite",
  "plans.over_limit.subtitle": "Cuentas con limites excedidos segun el snapshot operativo.",
  "plans.over_limit.empty": "Ninguna cuenta sobre limite.",
  "llm_usage.title": "Consumo LLM",
  "llm_usage.subtitle": "Tokens reales de LLM sin costos ni embeddings.",
  "llm_usage.records": "Registros",
  "llm_usage.query_records": "Consultas",
  "llm_usage.document_records": "Documentos",
  "llm_usage.total_tokens": "Tokens totales",
  "admin.title": "Administración",
  "admin.members": "Miembros",
  "admin.invite": "Invitar",
  "admin.pending": "Invitaciones pendientes",
  "admin.roles": "Roles",
  "admin.experts": "Expertos",
  "admin.experts.title": "Expertos de la cuenta",
  "admin.experts.subtitle": "Activa los expertos que usará tu cuenta, como plugins. Solo los activados aparecen en el chat. La configuración de cada experto es del sistema.",
  "admin.experts.enabledCount": "activados",
  "admin.experts.loading": "Cargando expertos…",
  "admin.experts.loadError": "No se pudieron cargar los expertos.",
  "admin.experts.saveError": "No se pudo actualizar el experto.",
  "admin.experts.enabled": "Activo",
  "admin.experts.disabled": "Inactivo",
  "admin.experts.enable": "Activar",
  "admin.experts.disable": "Desactivar",
  "admin.experts.tooltipTitle": "Cómo enriquece tu consulta",
  "admin.experts.customBadge": "Personalizado",
  "admin.experts.create": "Crear experto",
  "admin.experts.createTitle": "Nuevo experto",
  "admin.experts.createSubtitle": "Este experto será privado de tu cuenta. Cuéntanos cómo debe responder; nosotros armamos el resto.",
  "admin.experts.fieldName": "Nombre",
  "admin.experts.fieldNamePlaceholder": "Ej. Experto en contratos",
  "admin.experts.fieldDescription": "Descripción corta (opcional)",
  "admin.experts.fieldDescriptionPlaceholder": "Ej. Revisa contratos y señala riesgos",
  "admin.experts.fieldIcon": "Icono",
  "admin.experts.fieldInstruction": "¿Cómo debe responder?",
  "admin.experts.fieldInstructionPlaceholder": "Ej. Actúa como abogado de contratos: identifica cláusulas clave, obligaciones y riesgos, y sugiere qué revisar. Sé claro y prudente.",
  "admin.experts.instructionHint": "Escríbelo en lenguaje natural. Nosotros lo convertimos en el comportamiento del experto.",
  "admin.experts.createSubmit": "Crear",
  "admin.experts.creating": "Creando…",
  "admin.experts.createError": "No se pudo crear el experto.",
  "admin.experts.cancel": "Cancelar",
  "admin.experts.delete": "Eliminar",
  "admin.experts.deleteConfirm": "¿Eliminar el experto",
  "admin.experts.deleteError": "No se pudo eliminar el experto.",
  "admin.settings.title": "Administración",
  "admin.settings.organizationName": "Nombre de la organización",
  "admin.settings.inviteExpiryDays": "Días de expiración de invitaciones (1-60)",
  "admin.settings.allowedDomains": "Dominios permitidos (separados por coma o línea)",
  "admin.settings.defaultRole": "Rol por defecto",
  "admin.settings.locale": "Configuración regional",
  "admin.members.title": "Miembros de la organización",
  "admin.invite.title": "Invitar usuario",
  "admin.invite.send": "Enviar invitación",
  "admin.invite.invitations": "Invitaciones",
  "admin.invite.resend": "Reenviar invitación",
  "admin.invite.revoke": "Revocar invitación",
  "admin.invite.empty": "No hay invitaciones para mostrar.",
  "admin.roles.title": "Roles y permisos",
  "admin.roles.permissions": "Permisos",
  "admin.roles.delete": "Eliminar rol",
};
